import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { applyCountryLocaleResources } from "@/lib/countryLocaleOverlay";
import { countryKeyFromOrg } from "@/lib/countryProfile";
import { useAuth } from "@/hooks/useAuth";

/**
 * US construction wording is an overlay on the active UI language.
 * Brazil + English keeps the current English (CNPJ, diary, service front).
 */
export function CountryLocaleOverlay(): null {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const countryKey = countryKeyFromOrg(user?.organization ?? null);
  const language = i18n.resolvedLanguage ?? i18n.language;

  useEffect(() => {
    applyCountryLocaleResources(i18n, language, countryKey);
  }, [countryKey, i18n, language]);

  return null;
}
